// components/ReviewCard.jsx

import React from "react";
import { Paper, Typography } from "@material-ui/core";

const ReviewCard = ({ title, children }) => (
  <Paper
    elevation={0}
    style={{
      borderRadius: 12,
      border: "1px solid #E6EAF2",
      padding: 24,
      marginBottom: 24,
      background: "#fff",
    }}
  >
    <Typography
      style={{
        fontSize: 22,
        fontWeight: 600,
        color: "#1B2A4E",
        marginBottom: 20,
      }}
    >
      {title}
    </Typography>

    {children}
  </Paper>
);

export default ReviewCard;